module.exports = __webpack_public_path__ + "img/gPay-Support-Active.f0bf7eb2.svg";